import RegistrationModal from './RegistrationModal';

export { RegistrationModal };
export default RegistrationModal;
